import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { apiFetch } from 'utils/apiUtils';

interface RemoveNotificationsVariables {
  ids: string[];
}

export default function useRemoveNotifications() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['notifications', 'remove'],
    mutationFn: async ({ ids }: RemoveNotificationsVariables) => apiFetch<void>({
      path: 'notifications/remove',
      method: 'PATCH',
      accessToken: String(tokens.accessToken),
      body: { notificationIds: ids },
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['notifications'] });
    },
  });
}
